import React from "react";

const Stat_Population_Mean_Estimation = () => {
  return (
    <div>
      <h1>Stat Population Mean Estimation</h1>
    </div>
  );
};

export default Stat_Population_Mean_Estimation;
